import type { HTMLAttributes } from "react";
import { cx } from "~/utils/cva";

export const Stars = ({ className, ...props }: HTMLAttributes<HTMLElement>) => {
  return (
    <div className={cx("stars blur-[0.5px]", className)} {...props}>
      <svg
        aria-label="Logo"
        className="fill-current"
        height="731"
        role="img"
        width="872"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="227.718" cy="547.745" opacity="0.11" r="1.175" />
        <circle cx="234.593" cy="551.333" r="0.881" />
        <circle cx="244.14" cy="530.439" r="0.881" />
        <circle cx="201.625" cy="556.626" r="0.881" />
        <circle cx="184.75" cy="584.029" opacity="0.11" r="1.175" />
        <circle cx="168.68" cy="579.757" r="0.587" />
        <circle cx="239.023" cy="568.411" r="0.587" />
        <circle cx="346.422" cy="498.718" r="0.587" />
        <circle cx="382.851" cy="437.268" r="0.587" />
        <circle cx="425.406" cy="460.761" r="0.587" />
        <circle cx="66.984" cy="662.554" r="0.587" />
        <circle cx="42.336" cy="640.746" opacity="0.11" r="0.587" />
        <circle cx="28.508" cy="665.823" opacity="0.11" r="0.587" />
        <circle cx="63.945" cy="684.832" opacity="0.11" r="0.587" />
        <circle cx="168.398" cy="589.039" opacity="0.11" r="0.587" />
        <circle cx="249.555" cy="586.785" opacity="0.11" r="0.587" />
        <circle cx="340.937" cy="520.477" opacity="0.11" r="0.587" />
        <circle cx="81.656" cy="635.531" opacity="0.3" r="0.587" />
        <circle cx="177.695" cy="535.399" r="0.587" />
        <circle cx="252.922" cy="485.182" r="0.587" />
        <circle cx="173.609" cy="602.461" r="0.587" />
        <circle cx="139.125" cy="624.841" opacity="0.3" r="0.587" />
        <circle cx="78.914" cy="620.51" opacity="0.11" r="0.587" />
        <circle cx="194.242" cy="541.467" opacity="0.3" r="0.587" />
        <circle cx="188.062" cy="606.386" opacity="0.3" r="0.587" />
        <circle cx="131.648" cy="649.995" opacity="0.3" r="0.587" />
        <circle cx="95.945" cy="626.262" opacity="0.3" r="0.587" />
        <circle cx="401.398" cy="425.934" opacity="0.3" r="0.587" />
        <circle cx="308.976" cy="457.205" opacity="0.11" r="0.587" />
        <circle cx="401.844" cy="455.746" opacity="0.11" r="0.587" />
        <circle cx="279.765" cy="540.572" opacity="0.3" r="1.175" />
        <circle cx="299.242" cy="506.931" opacity="0.11" r="1.175" />
        <circle cx="287.968" cy="490.095" r="0.881" />
        <circle cx="287.547" cy="563.88" r="0.881" />
        <circle cx="457.492" cy="467.594" r="0.881" />
        <circle cx="132.336" cy="666.701" r="0.881" />
        <circle cx="59.468" cy="697.889" r="0.881" />
        <circle cx="38.304" cy="683.619" r="0.881" />
        <circle cx="270.718" cy="515.293" r="0.881" />
        <circle cx="208.656" cy="607.374" r="0.881" />
        <circle cx="346.547" cy="547.995" r="0.881" />
        <circle cx="455.351" cy="429.776" r="0.881" />
        <circle cx="449.593" cy="395.009" r="0.881" />
        <circle cx="328.773" cy="463.965" opacity="0.3" r="1.175" />
        <circle cx="306.07" cy="428.99" r="1.175" />
        <circle cx="361.336" cy="458.586" r="0.881" />
        <circle cx="372.601" cy="423.621" opacity="0.3" r="1.175" />
        <circle cx="444.07" cy="426.948" opacity="0.3" r="1.175" />
        <circle cx="387.07" cy="465.337" opacity="0.3" r="1.175" />
        <circle cx="109.734" cy="657.216" opacity="0.3" r="1.175" />
        <circle cx="52.242" cy="656.018" opacity="0.3" r="1.175" />
        <circle cx="414.281" cy="425.277" opacity="0.11" r="1.175" />
        <circle cx="111.82" cy="593.553" opacity="0.3" r="1.175" />
        <circle cx="92.125" cy="592.332" opacity="0.11" r="1.175" />
        <circle cx="108.648" cy="626.417" opacity="0.3" r="1.175" />
        <circle cx="139.273" cy="606.191" r="0.881" />
        <circle cx="300.453" cy="286.747" opacity="0.11" r="1.175" />
        <circle cx="307.328" cy="290.336" r="0.881" />
        <circle cx="316.875" cy="269.441" r="0.881" />
        <circle cx="274.359" cy="295.629" r="0.881" />
        <circle cx="257.484" cy="323.031" opacity="0.11" r="1.175" />
        <circle cx="241.414" cy="318.76" r="0.587" />
        <circle cx="311.758" cy="307.413" r="0.587" />
        <circle cx="419.156" cy="237.721" r="0.587" />
        <circle cx="455.586" cy="176.271" r="0.587" />
        <circle cx="498.14" cy="199.766" r="0.587" />
        <circle cx="139.719" cy="401.556" r="0.587" />
        <circle cx="115.07" cy="379.748" opacity="0.11" r="0.587" />
        <circle cx="101.242" cy="404.825" opacity="0.11" r="0.587" />
        <circle cx="136.68" cy="423.834" opacity="0.11" r="0.587" />
        <circle cx="241.133" cy="328.041" opacity="0.11" r="0.587" />
        <circle cx="322.289" cy="325.787" opacity="0.11" r="0.587" />
        <circle cx="413.672" cy="259.479" opacity="0.11" r="0.587" />
        <circle cx="154.39" cy="374.534" opacity="0.3" r="0.587" />
        <circle cx="250.43" cy="274.401" r="0.587" />
        <circle cx="325.656" cy="224.184" r="0.587" />
        <circle cx="246.344" cy="341.464" r="0.587" />
        <circle cx="211.859" cy="363.843" opacity="0.3" r="0.587" />
        <circle cx="151.648" cy="359.513" opacity="0.11" r="0.587" />
        <circle cx="266.976" cy="280.469" opacity="0.3" r="0.587" />
        <circle cx="260.797" cy="345.388" opacity="0.3" r="0.587" />
        <circle cx="204.383" cy="388.998" opacity="0.3" r="0.587" />
        <circle cx="168.68" cy="365.264" opacity="0.3" r="0.587" />
        <circle cx="474.133" cy="164.936" opacity="0.3" r="0.587" />
        <circle cx="381.711" cy="196.208" opacity="0.11" r="0.587" />
        <circle cx="474.578" cy="194.749" opacity="0.11" r="0.587" />
        <circle cx="352.5" cy="279.575" opacity="0.3" r="1.175" />
        <circle cx="371.976" cy="245.933" opacity="0.11" r="1.175" />
        <circle cx="360.703" cy="229.097" r="0.881" />
        <circle cx="360.281" cy="302.882" r="0.881" />
        <circle cx="530.226" cy="206.596" r="0.881" />
        <circle cx="205.07" cy="405.703" r="0.881" />
        <circle cx="132.203" cy="436.891" r="0.881" />
        <circle cx="111.039" cy="422.621" r="0.881" />
        <circle cx="343.453" cy="254.296" r="0.881" />
        <circle cx="281.39" cy="346.376" r="0.881" />
        <circle cx="419.281" cy="286.997" r="0.881" />
        <circle cx="528.086" cy="168.778" r="0.881" />
        <circle cx="522.328" cy="134.012" r="0.881" />
        <circle cx="401.507" cy="202.967" opacity="0.3" r="1.175" />
        <circle cx="378.804" cy="167.992" r="1.175" />
        <circle cx="434.07" cy="197.588" r="0.881" />
        <circle cx="445.336" cy="162.623" opacity="0.3" r="1.175" />
        <circle cx="516.804" cy="165.95" opacity="0.3" r="1.175" />
        <circle cx="459.804" cy="204.339" opacity="0.3" r="1.175" />
        <circle cx="182.468" cy="396.218" opacity="0.3" r="1.175" />
        <circle cx="124.976" cy="395.021" opacity="0.3" r="1.175" />
        <circle cx="487.015" cy="164.279" opacity="0.11" r="1.175" />
        <circle cx="184.554" cy="332.556" opacity="0.3" r="1.175" />
        <circle cx="164.859" cy="331.334" opacity="0.11" r="1.175" />
        <circle cx="181.382" cy="365.42" opacity="0.3" r="1.175" />
        <circle cx="212.008" cy="345.193" r="0.881" />
        <circle cx="609.586" cy="195.828" opacity="0.11" r="1.175" />
        <circle cx="616.461" cy="199.416" r="0.881" />
        <circle cx="626.008" cy="178.522" r="0.881" />
        <circle cx="583.492" cy="204.709" r="0.881" />
        <circle cx="566.617" cy="232.111" opacity="0.11" r="1.175" />
        <circle cx="550.547" cy="227.84" r="0.587" />
        <circle cx="620.89" cy="216.494" r="0.587" />
        <circle cx="728.289" cy="146.801" r="0.587" />
        <circle cx="764.719" cy="85.351" r="0.587" />
        <circle cx="807.273" cy="108.844" r="0.587" />
        <circle cx="448.851" cy="310.637" r="0.587" />
        <circle cx="424.203" cy="288.829" opacity="0.11" r="0.587" />
        <circle cx="410.375" cy="313.906" opacity="0.11" r="0.587" />
        <circle cx="445.812" cy="332.915" opacity="0.11" r="0.587" />
        <circle cx="550.265" cy="237.121" opacity="0.11" r="0.587" />
        <circle cx="631.414" cy="234.868" opacity="0.11" r="0.587" />
        <circle cx="722.805" cy="168.56" opacity="0.11" r="0.587" />
        <circle cx="463.523" cy="283.614" opacity="0.3" r="0.587" />
        <circle cx="559.562" cy="183.482" r="0.587" />
        <circle cx="634.789" cy="133.265" r="0.587" />
        <circle cx="555.476" cy="250.545" r="0.587" />
        <circle cx="520.992" cy="272.924" opacity="0.3" r="0.587" />
        <circle cx="460.781" cy="268.593" opacity="0.11" r="0.587" />
        <circle cx="576.109" cy="189.55" opacity="0.3" r="0.587" />
        <circle cx="569.93" cy="254.469" opacity="0.3" r="0.587" />
        <circle cx="513.515" cy="298.078" opacity="0.3" r="0.587" />
        <circle cx="477.812" cy="274.345" opacity="0.3" r="0.587" />
        <circle cx="783.265" cy="74.017" opacity="0.3" r="0.587" />
        <circle cx="690.844" cy="105.288" opacity="0.11" r="0.587" />
        <circle cx="783.711" cy="103.829" opacity="0.11" r="0.587" />
        <circle cx="661.632" cy="188.655" opacity="0.3" r="1.175" />
        <circle cx="681.109" cy="155.014" opacity="0.11" r="1.175" />
        <circle cx="669.836" cy="138.178" r="0.881" />
        <circle cx="669.414" cy="211.963" r="0.881" />
        <circle cx="839.359" cy="115.677" r="0.881" />
        <circle cx="514.203" cy="314.784" r="0.881" />
        <circle cx="441.336" cy="345.972" r="0.881" />
        <circle cx="420.172" cy="331.702" r="0.881" />
        <circle cx="652.586" cy="163.376" r="0.881" />
        <circle cx="590.523" cy="255.457" r="0.881" />
        <circle cx="728.414" cy="196.078" r="0.881" />
        <circle cx="837.219" cy="77.859" r="0.881" />
        <circle cx="831.461" cy="43.092" r="0.881" />
        <circle cx="710.632" cy="112.048" opacity="0.3" r="1.175" />
        <circle cx="687.937" cy="77.073" r="1.175" />
        <circle cx="743.203" cy="106.669" r="0.881" />
        <circle cx="754.468" cy="71.704" opacity="0.3" r="1.175" />
        <circle cx="825.937" cy="75.031" opacity="0.3" r="1.175" />
        <circle cx="768.937" cy="113.42" opacity="0.3" r="1.175" />
        <circle cx="491.601" cy="305.299" opacity="0.3" r="1.175" />
        <circle cx="434.109" cy="304.102" opacity="0.3" r="1.175" />
        <circle cx="796.148" cy="73.36" opacity="0.11" r="1.175" />
        <circle cx="493.687" cy="241.636" opacity="0.3" r="1.175" />
        <circle cx="473.992" cy="240.415" opacity="0.11" r="1.175" />
        <circle cx="490.515" cy="274.5" opacity="0.3" r="1.175" />
        <circle cx="521.14" cy="254.274" r="0.881" />
      </svg>
    </div>
  );
};
